import React, { 
  useState, 
  useRef, 
  //useCallback,
} from 'react';
import { HashLink, scrollWithOffset } from './hashlink'
import { Link } from "gatsby"
import NavItemSocialIcons from "../navigation/NavItemSocialIcons"
import {
  Menu,
  Dropdown,
  Icon,
  Button,
} from 'semantic-ui-react';

export default function NavItemLink(props) {
  //console.log('NavItemLink - props', props);

  const textColor = props.textColor ? props.textColor : props.header_text_color ? props.header_text_color : null;

  const [activeItem, setActiveItem] = useState('');
  const handleItemClick = (e, titleProps) => {
    const { name } = titleProps;
    if (name !== activeItem) {
      setActiveItem(name);
    }
    props.handleSidebarHide()
  }

  const [activeDropdownItem, setActiveDropdownItem] = useState('');
  const handleMobileItemToggle = (selectedNavItemName) => {
    //console.log('NavItemLink - handleMobileItemToggle - selectedNavItemName', selectedNavItemName);
    if (selectedNavItemName !== activeDropdownItem) {
      setActiveDropdownItem(selectedNavItemName);
    } else {
      setActiveDropdownItem('');
    }
  }

  let navItemParentContainerRef = useRef(null);
  let subMenuContainerRefs = useRef([]);
  const [navItemExpandedMenuState, setNavItemExpandedMenuState] = useState({
    navItemId: null,
    navItemParentHeight: null,
    navItemSubMenuPositionY: null,
  });

  //const [navItemParentHeightState, setNavItemParentHeightState] = useState(null);
  //console.debug('NavItemLink - navItemParentContainerRef', navItemParentContainerRef);

  const handleMouseOver = (e, index) => {
    //console.debug('NavItemLink - handleMouseOver - e, index', {e, index, navItemParentContainerRef: navItemParentContainerRef.current.getBoundingClientRect(), subMenuContainerRef: subMenuContainerRefs.current[index].getBoundingClientRect()});
    const navItemId = props.contentItemId+'-'+index;
    //console.debug('NavItemLink - handleMouseOver - navItemId', navItemId);
    //console.debug('NavItemLink - handleMouseOver - navItemExpandedMenuState.navItemId', navItemExpandedMenuState.navItemId);
    if ((navItemId !== navItemExpandedMenuState.navItemId)) {
      const contentHeight = navItemParentContainerRef.current && navItemParentContainerRef.current.offsetHeight+2;
      const menuPositionY = navItemParentContainerRef.current && navItemParentContainerRef.current.getBoundingClientRect().y;
      const subMenuPosition = subMenuContainerRefs.current[index] && subMenuContainerRefs.current[index].getBoundingClientRect();
      //console.debug('NavItemLink - handleMouseOver - menuPositionY, subMenuPosition', {menuPositionY, subMenuPosition});
      const contentPositionY = menuPositionY && subMenuPosition.y ? -(subMenuPosition.y - menuPositionY) : null;
      //console.debug('NavItemLink - contentPositionY', contentPositionY);
      setNavItemExpandedMenuState({
        navItemId,
        navItemParentHeight: contentHeight,
        navItemSubMenuPositionY: contentPositionY,
      });
    }
    /* if (navItemParentContainerRef && !navItemParentHeightState) {
      //const contentHeight = navItemParentContainerRef.current && navItemParentContainerRef.current.getBoundingClientRect().height;
      const contentHeight = navItemParentContainerRef.current && navItemParentContainerRef.current.offsetHeight +2;
      //console.debug('NavItemLink - contentHeight', contentHeight);
      setNavItemParentHeightState(contentHeight);
    } */
  };

  //console.debug('NavItemLink - navItemExpandedMenuState', navItemExpandedMenuState);
  //console.debug('NavItemLink - subMenuContainerRefs', subMenuContainerRefs);

  return (
    <>
      {(() => {
        switch(props.pageArea) {
          case 'mobile-sidebar-nav':
            //console.debug('mobile-sidebar-nav props', props)
            return (
              <>
                {props.navItems && props.navItems.contentItems.length !== 0 ?
                  <Menu.Item as={'div'} aria-label={props.text+' Navigation Items'}>
                    <Menu.Header onClick={()=>handleMobileItemToggle(props.text)}>
                      {props.text} 
                      <Button floated={'right'} icon>
                        <Icon rotated={activeDropdownItem === props.text ? 'clockwise' : null} size={'large'} name='triangle right' />
                      </Button>
                    </Menu.Header>
                    <Menu.Menu className={activeDropdownItem === props.text ? 'visible' : 'hidden'}>
                      {props.navItems.contentItems.map((navItem, i) => {
                        //console.debug('navItem', navItem)
                        return (
                          (navItem.navItems && navItem.navItems.contentItems.length !== 0 ?
                            <React.Fragment key={i}>
                              <Menu.Item aria-label={navItem.text+' Navigation Item'}
                                name={navItem.text}
                                active={activeItem === navItem.text}
                                onClick={handleItemClick}
                                as={navItem.internalLink.url !== null ? Link : navItem.externalLink.url !== null ? 'a' : null}
                                to={navItem.internalLink.url !== null ? navItem.internalLink.url : null}
                                href={navItem?.externalLink?.url ? navItem.externalLink.url : null}
                                target={navItem?.externalLink?.url ? '_blank' : null}
                                rel={navItem?.externalLink?.url ? 'noreferrer' : null}
                              >
                                {navItem.text}
                              </Menu.Item>
                              <Menu.Menu>
                                {navItem.navItems.contentItems.map((navItemItem, i) => {
                                  return (
                                    <Menu.Item key={i} aria-label={navItemItem.text+' Navigation Item'}
                                      name={navItemItem.text}
                                      active={activeItem === navItemItem.text}
                                      onClick={handleItemClick}
                                      as={navItemItem.internalLink.url !== null ? Link : navItemItem.externalLink.url !== null ? 'a' : null}
                                      to={navItemItem.internalLink.url !== null ? navItemItem.internalLink.url : null}
                                      href={navItemItem?.externalLink?.url ? navItemItem.externalLink.url : null}
                                      target={navItemItem?.externalLink?.url ? '_blank' : null}
                                      rel={navItemItem?.externalLink?.url ? 'noreferrer' : null}
                                    >
                                      {navItemItem.text}
                                    </Menu.Item>
                                  )
                                })}
                              </Menu.Menu>
                            </React.Fragment>
                          : navItem.contentType === 'NavItemSocial' ?
                              null
                          :
                            <Menu.Item key={i} aria-label={navItem.text+' Navigation Item'}
                              name={navItem.text}
                              active={activeItem === navItem.text}
                              onClick={handleItemClick}
                              as={navItem.internalLink.url !== null ? Link : navItem.externalLink.url !== null ? 'a' : null}
                              to={navItem.internalLink.url !== null ? navItem.internalLink.url : null}
                              href={navItem?.externalLink?.url ? navItem.externalLink.url : null}
                              target={navItem?.externalLink?.url ? '_blank' : null}
                              rel={navItem?.externalLink?.url ? 'noreferrer' : null}
                            >
                              {navItem.text}
                            </Menu.Item>
                          )
                        )
                      })}
                    </Menu.Menu>
                  </Menu.Item>
                :
                  <Menu.Item as={HashLink} aria-label={props.text+' Navigation Item'}
                    style={{ color: textColor, }}
                    href={props.dOMID}
                    scroll={el => scrollWithOffset(el, 80)}
                    onClick={()=>{props.handleSidebarHide()}}
                    position={props.position ? props.position : null}
                  >
                    {props.text}
                  </Menu.Item>
                }
              </>
            );
          case 'main-nav-container':
            //console.debug('top level nav', props);
            return (
              (props.navItems && props.navItems.contentItems.length !== 0 ?
                <Dropdown item simple aria-label={props.text+' Navigation Items'}
                  className={'item-dropwdown-wrapper ' + (props.position ? props.position : null)}
                  style={{ color: textColor, }}
                  text={props.text}
                  open={false}
                  //open={props.contentItemId === '4rs10sgscp3f3sbn0r2d3m3xwz'}
                >
                  <Dropdown.Menu>
                    <div ref={navItemParentContainerRef} style={{position: 'absolute', height: '100%'}}></div>
                    {props.navItems.contentItems.map((navItem, i) => {
                      //console.debug('navItem', navItem);
                      //let linkType = navItem.internalLink.url !== null ? 'internal' : navItem.externalLink.url !== null ? 'external' : 'unknown';
                      //console.debug('linkType', linkType);
                      //console.debug('navItem', navItem);
                      return (
                        (navItem.contentType === 'NavItemLink' && navItem.navItems && navItem.navItems.contentItems.length !== 0 ?
                          <Dropdown.Item key={i} 
                            //onMouseOver={handleMouseOver}
                            //onMouseOut={handleMouseOut}
                          >
                            {/* <Icon name='dropdown' role="img" aria-label="Dropdown Icon" />
                            <span className='text'>
                              {navItem.text}
                            </span> */}
                            <Dropdown item simple aria-label={navItem.text+' Navigation Items'}
                              className={'item-dropwdown-wrapper'} 
                              text={navItem.text}
                              onMouseOver={(e)=>handleMouseOver(e,i)}
                              open={false}
                              //onOpen={handleOpen}
                              //onMouseOver={(e) => e.stopPropagation()}
                              //onMouseOut={(e) => handleMouseOut(e,i)}
                              //open={true}
                              //open={navItem.contentItemId === '4n5dm9bk7tkck17q9r1kyjq7dc'}
                            >
                              <Dropdown.Menu
                                style={navItemExpandedMenuState.navItemId === (props.contentItemId+'-'+i) ? { height: navItemExpandedMenuState.navItemParentHeight, transform: 'translateY('+navItemExpandedMenuState.navItemSubMenuPositionY+'px)', } : null}
                                onMouseOver={(e) => e.stopPropagation()}
                                onMouseOut={(e) => e.stopPropagation()}
                              >
                                <div ref={el => (subMenuContainerRefs.current[i] = el)} style={{position: 'absolute', height: '100%'}}></div>
                                {/* <div ref={subMenuContainerRef} style={{position: 'absolute', height: '100%'}}></div> */}
                                {navItem.navItems.contentItems.map((navItemItem, i) => {
                                  //let linkTypeChild = navItemItem.internalLink.url !== null ? 'internal' : navItemItem.externalLink.url !== null ? 'external' : 'unknown';
                                  //console.debug('linkTypeChild', linkTypeChild);
                                  //console.debug('navItemItem', navItemItem);
                                  return (
                                    <Dropdown.Item key={i} aria-label={navItemItem.text+' Navigation Item'}
                                      as={navItemItem.internalLink.url !== null ? Link : navItemItem.externalLink.url !== null ? 'a' : null}
                                      to={navItemItem.internalLink.url !== null ? navItemItem.internalLink.url : null}
                                      href={navItemItem?.externalLink?.url ? navItemItem.externalLink.url : null}
                                      target={navItemItem?.externalLink?.url ? '_blank' : null}
                                      rel={navItemItem?.externalLink?.url ? 'noreferrer' : null}
                                    >
                                      {navItemItem.text}
                                    </Dropdown.Item>
                                  )
                                }
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Dropdown.Item>
                        : navItem.contentType === 'NavItemSocial' ?
                          <NavItemSocialIcons key={i} pageArea={props.pageArea+'-dropdown-item'} index={i} navItem={navItem} />
                        :
                          <Dropdown.Item key={i} aria-label={navItem.text+' Navigation Item'}
                            as={navItem.internalLink.url !== null ? Link : navItem.externalLink.url !== null ? 'a' : null}
                            to={navItem.internalLink.url !== null ? navItem.internalLink.url : null}
                            href={navItem?.externalLink?.url ? navItem.externalLink.url : null}
                            target={navItem?.externalLink?.url ? '_blank' : null}
                            rel={navItem?.externalLink?.url ? 'noreferrer' : null}
                          >
                            {navItem.text}
                          </Dropdown.Item>
                        )
                      )
                    }
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              :
                <Menu.Item as={HashLink} aria-label={props.text+' Navigation Item'}
                  style={{ color: textColor, }}
                  href={props.dOMID}
                  scroll={el => scrollWithOffset(el, 80)}
                  position={props.position ? props.position : null}
                >
                  {props.text}
                </Menu.Item>
              )
            );
          default:
            return null;
        }
      })()}
    </>
  )
}
